import type { AppData, CaseChargeRow, CaseEventFlagRow, CaseEventHighlight, CaseSearchRow, ChartsData, FinancialPreview, Methodology, SearchRow, Summary } from "./types";

async function loadJson<T>(path: string): Promise<T> {
  const response = await fetch(path);
  if (!response.ok) {
    throw new Error(`Unable to load ${path}: ${response.status}`);
  }
  return response.json() as Promise<T>;
}

export async function loadAppData(): Promise<AppData> {
  const [
    summary,
    charts,
    search,
    cases,
    judges,
    caseContextSummary,
    caseContextCharts,
    caseJudges,
    caseDataQuality,
    dataDictionary,
    methodology,
    financialPreview
  ] =
    await Promise.all([
      loadJson<Summary>("/data/summary.json"),
      loadJson<ChartsData>("/data/charts.json"),
      loadJson<SearchRow[]>("/data/search.json"),
      loadJson<AppData["cases"]>("/data/cases.json"),
      loadJson<AppData["judges"]>("/data/judges.json"),
      loadJson<AppData["caseContextSummary"]>("/data/case-context-summary.json"),
      loadJson<AppData["caseContextCharts"]>("/data/case-context-charts.json"),
      loadJson<AppData["caseJudges"]>("/data/case-judges.json"),
      loadJson<AppData["caseDataQuality"]>("/data/case-data-quality.json"),
      loadJson<Record<string, string>>("/data/data-dictionary.json"),
      loadJson<Methodology>("/data/methodology.json"),
      loadJson<FinancialPreview>("/data/financial-preview.json")
    ]);

  return { summary, charts, search, cases, judges, caseContextSummary, caseContextCharts, caseJudges, caseDataQuality, dataDictionary, methodology, financialPreview };
}

export function loadCaseSearchRows(): Promise<CaseSearchRow[]> {
  return loadJson<CaseSearchRow[]>("/data/case-search.json");
}

export function loadCaseCharges(): Promise<CaseChargeRow[]> {
  return loadJson<CaseChargeRow[]>("/data/case-charges.json");
}

export function loadCaseEventHighlights(): Promise<CaseEventHighlight[]> {
  return loadJson<CaseEventHighlight[]>("/data/case-event-highlights.json");
}

export function loadCaseEventFlags(): Promise<CaseEventFlagRow[]> {
  return loadJson<CaseEventFlagRow[]>("/data/case-event-flags.json");
}
